import React, { useState } from 'react';
import { BsPencilFill } from 'react-icons/bs';
import { LookupInput } from '@components';
import { LoginScreen, SignupScreen } from '@pages';
import { HandleAuthPopupProps, HandleInputToggleProps } from '@interface';
import { useSelector } from 'react-redux';
import { RootState } from '@store';
export const HandleInputToggle: React.FC<HandleInputToggleProps> = ({
	isInputOpen,
	handleSearchToggle,
	navigaterFunction,
}) => {
	const { addressState:{ properties: { name, borough, postalcode}} } = useSelector((state: RootState) => state.rootSlice.application);
	return isInputOpen ? (
		<div className="w-full md:w-[500px]">
			<LookupInput navigaterFunction={navigaterFunction} />
		</div>
	) : (
		<div
			className="inline-flex w-[full]
                        items-center outline-none space-x-2 font-bold text-[14px]"
			>
			<p>{`${name}, ${borough}${borough && ','}${postalcode}`}</p>
			<button
				className="hover:btn-dark p-2 rounded-sm"
				onClick={handleSearchToggle}
			>
				<BsPencilFill />
			</button>
		</div>
	);
};

export const HandleAuthPopup: React.FC<HandleAuthPopupProps> = ({
	modelref,
	closeModal,
}) => {
	const [isSignup, setIsSignup] = useState<boolean>(false);

	const toggleSignup = () => {
		setIsSignup(true);
	};

	return (
		<div>
			{isSignup ? (
				<SignupScreen modelref={modelref} closeModal={closeModal} />
			) : (
				<LoginScreen
					modelref={modelref}
					closeModal={closeModal}
					toggleSignup={toggleSignup}
				/>
			)}
		</div>
	);
};